<template>
  <aha-modal
    :mobile-max-height="true"
    :no-margin-padding="true"
    :visible-overflow="true"
    size="md"
    :title="title"
    :backable="openTabContent"
    classes-modal="only-mobile-back-button"
    @back="back"
    @hide="hideModal"
  >
    <div
      class="tab-content tab-content__editor-share-v2-modal"
    >
      <div class="side-center h-full" :class="{'mobile-open-tab-content': openTabContent}">
        <SideCenterAddEditor
          :folder="folder"
          @prepareDataForInviteTeamModal="prepareDataForInviteTeamModal"
          :shareTeam="false"
        ></SideCenterAddEditor>
      </div>
    </div>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import SideCenterAddEditor from '@/components-v2/editor-share-v2/SideCenterAddEditor'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    SideCenterAddEditor,
  },
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    source: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      toBeInvitedMembers: null,
      activeTab: 'inviteAudience',
      openTabContent: false,
      title: `${this.$i18nPresenter.t('Share')} ‘${this.folder.folderName}’`,
      mapTitle: {
        inviteAudience: this.$i18nPresenter.t('Invite Audience'),
        addEditor: this.$i18nPresenter.t('Add Collaborators'),
        shareSlides: this.$i18nPresenter.t('Share Slides'),
        publishTemplate: this.$i18nPresenter.t('Publish'),
      },
      mappingEventAction: {
        inviteAudience: 'Share menu > Invite Audience',
        addEditor: 'Share menu > Add Collaborators',
        shareSlides: 'Share menu > Share Slides',
        publishTemplate: 'Share menu > Publish',
      },
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isMobile() {
      return window.innerWidth < 768
    },
    inviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
  },
  created() {
    if (this.$store.state.presentation.defaultTabShare) {
      this.selectItem(this.$store.state.presentation.defaultTabShare)
      this.$store.state.presentation.defaultTabShare = ''
    }
  },
  methods: {
    tracking(item) {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        this.mappingEventAction[item], null, null, {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
          isPresentationOwner: this.presentation.userId === this.currentUser.id,
        },
      )
    },
    selectItem(item) {
      this.activeTab = item
      this.openTabContent = true
      if (this.isMobile) {
        this.title = this.mapTitle[item]
      }
      this.tracking(item)
    },
    back() {
      this.title = 'Share'
      this.openTabContent = false
    },
    hideModal() {
      this.$emit('hide', {
        toBeInvitedMembers: this.toBeInvitedMembers,
      })
    },
    prepareDataForInviteTeamModal({ toBeInvitedMembers }) {
      this.toBeInvitedMembers = toBeInvitedMembers
    },
  },
}
</script>

<style lang="scss" scoped>

.tab-content__editor-share-v2-modal {
  display: flex;
  // height: fit-content;
  height: 100%;
  min-height: 400px;

  .side-left {
    flex-shrink: 0;
    border-right: 1px solid rgba(239, 241, 247, 1);
    width: 200px;

    .side-left-container {
      .side-left-item {
        &:hover {
          cursor: pointer;
        }

        &.active {
          background: rgba(236, 244, 254, 1);
          font-weight: bold;

          .item-icon {
            color: rgba(25, 31, 45, 1);
          }

          .rectangle {
            visibility: visible;
          }
        }

        height: 48px;
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 14px;

        .item-icon {
          margin-left: 10px;
          margin-right: 10px;
          @apply text-base-70;
        }

        .rectangle {
          height: 100%;
          width: 8px;
          background: rgba(106, 30, 187, 1);
          visibility: hidden;
        }
      }
    }
  }

  .side-center {
    flex-grow: 1;
    padding: 15px 20px 20px;
  }
}

@media (max-width: 767.98px) {
  .tab-content__editor-share-v2-modal {
    display: flex;
    flex-direction: column;

    .side-left {
      width: 100%;
      margin-bottom: 15px;

      &.mobile-open-side-center {
        display: none;
      }

      .side-left-container {
        .side-left-item {
          &.active {
            background: inherit;
            font-weight: inherit;

            .item-icon {
              @apply text-base-70
            }

            .rectangle {
              visibility: hidden;
            }
          }
        }
      }
    }

    .side-center {

      &.mobile-open-tab-content {
        display: block;
      }
    }
  }
}
</style>
